// Ponte para disparar toasts fora da arvore React (ex.: interceptors do
// axios, que rodam fora de qualquer componente). ToastProvider registra a
// API real aqui assim que monta.
const bridge = { current: null };

export const registerToastApi = (api) => {
  bridge.current = api;
};

export const unregisterToastApi = () => {
  bridge.current = null;
};

export const showToast = (message, options) => {
  if (!bridge.current) return null;
  return bridge.current.show(message, options);
};

export default bridge;
